{
  "statementTransitions": {
    "fail": "Fail",
    "reconcile": "Reconcile"
  },
  "viewStatement": "View Statement",
  "table": {
    "client": "Client",
    "organization": "Organization",
    "account": "Account",
    "statementState": "Statement State",
    "statementType": "Statement Type",
    "actions": "Actions"
  },
  "transitionStatements": {
    "title": "Transition Statements",
    "bodyText": "This will transition {{totalCount}} statements to RECONCILED. This action cannot be undone. Do you want to continue?",
    "transitionStatementsButton": "Transition",
    "clearSelectionButton": "Clear Selection",
    "totalCount": "All {{totalCount}} statements selected",
    "selectAll": "Select all {{totalCount}} statements",
    "allRowsOnPageSelected": "All {{totalCount}} rows on this page selected. Total rows selected {{selectedCount}}",
    "rowsSelected": "{{selectedCount}} rows selected"
  },
  "statementStates": {
    "AWAITING_REVIEW": "Awaiting Review",
    "FAILED": "Failed",
    "RECONCILED": "Reconciled"
  },
  "statementTypes": {
    "OV_MONTHLY_ACCOUNT_STATEMENTS": "OneVest Monthly Account Statements",
    "ANNUAL_PERFORMANCE_REPORT": "Annual Performance Report",
    "ANNUAL_ACCOUNT_STATEMENTS": "Annual Account Statements",
    "QUARTERLY_ACCOUNT_STATEMENTS": "Quarterly Account Statements",
    "MONTHLY_ACCOUNT_STATEMENTS": "Monthly Account Statements",
    "CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS": "Consolidated Monthly Account Statements",
    "TAX_SLIPS_1099R": "Tax Slips 1099R",
    "TAX_SLIPS_LAST_10_MONTHS": "Tax Slips Last 10 Months",
    "TAX_SLIPS_FIRST_60_DAYS": "Tax Slips First 60 Days",
    "TAX_SLIPS_T4RSP_RL2": "Tax Slips T4RSP RL2",
    "TAX_SLIPS_T4RIF_RL2": "Tax Slips T4RIF RL2",
    "TAX_SLIPS_T4A_RL1": "Tax Slips T4A RL1",
    "TAX_SLIPS_NR4": "Tax Slips NR4",
    "TAX_SLIPS_T5008": "Tax Slips T5008",
    "TAX_SLIPS_TRADING_SUMMARY": "Tax Slips Trading Summary",
    "TAX_SLIPS_T5_RL3": "Tax Slips T5 RL3",
    "TAX_SLIPS_T3_RL16": "Tax Slips T3 RL16",
    "TAX_SLIPS_T3_BREAKDOWN": "Tax Slips T3 Breakdown",
    "TAX_SLIPS_T5013_RL15": "Tax Slips T5013 RL15",
    "MANAGEMENT_FEES_ANNUAL_REPORT": "Management Fees Annual Report",
    "ADMINISTRATIVE_FEES_ANNUAL_REPORT": "Administrative Fees Annual Report",
    "TAX_SLIP_GENERAL": "Tax Slip General",
    "TRADE_CONFIRMATION": "Trade Confirmation",
    "TAX_SLIPS_CONSOLIDATED_1099": "Tax Slips Consolidated 1099",
    "TAX_SLIPS_FORM_1042_S": "Tax Slips Form 1042 S",
    "TAX_SLIPS_FORM_1099_Q": "Tax Slips Form 1099 Q",
    "TAX_SLIPS_FORM_1099_R": "Tax Slips Form 1099 R",
    "TAX_SLIPS_FORM_2439": "Tax Slips Form 2439",
    "TAX_SLIPS_FORM_480_6A": "Tax Slips Form 480 6A",
    "TAX_SLIPS_FORM_480_6B": "Tax Slips Form 480 6B",
    "TAX_SLIPS_FORM_5498": "Tax Slips Form 5498",
    "TAX_SLIPS_T4_FHSA": "Tax Slips T4 FHSA"
  }
}
